// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__2CD1n","Title":"Tooltip_Title__dXBlF"};